import { View } from 'foundations-components/components/View';
import { ShortContentCompletedVideoView } from '../components/ShortContentCompletedVideoView';
import { VideoPlayerWithControls } from '../../video';
import { jsx as _jsx } from "react/jsx-runtime";
export const ShortContentVideo = ({
  additionalTracking,
  playlistId,
  displayInteractiveEducation,
  handleDisplayInteractiveEducation,
  interactiveEducationEnabled,
  short,
  viewProps
}) => {
  const isInCollection = !!playlistId;
  const {
    name,
    contentId
  } = short || {};
  if (!short) {
    return null;
  }
  return /*#__PURE__*/_jsx(View, Object.assign({}, viewProps, {
    children: /*#__PURE__*/_jsx(VideoPlayerWithControls, {
      additionalTracking: additionalTracking,
      completedVideoView: isInCollection ? undefined : /*#__PURE__*/_jsx(ShortContentCompletedVideoView, {
        isInCollection: false,
        short: short
      }),
      displayInteractiveEducation: displayInteractiveEducation,
      enableAdaptToIndustry: true,
      enableQuizMe: true,
      enableSummarize: true,
      handleDisplayInteractiveEducation: handleDisplayInteractiveEducation,
      interactiveEducationEnabled: interactiveEducationEnabled,
      isPubliclyVisible: true // TODO: Update this to read short visibility when available
      ,
      playlistId: playlistId,
      shortId: contentId,
      shortName: name
    })
  }));
};
export default ShortContentVideo;